import { cn } from '../../lib/utils'
import type { GraphResponse, GraphFilters } from './graphTypes'
import { NODE_THEME } from './graphTheme'

interface GraphStatsBarProps {
  stats?: GraphResponse['stats']
  filters: GraphFilters
  onFrameworkChange: (fw: GraphFilters['framework']) => void
}

const FW_OPTIONS: GraphFilters['framework'][] = ['ALL', 'US_GAAP', 'IFRS']
const FW_LABELS: Record<string, string> = { ALL: 'All', US_GAAP: 'US GAAP', IFRS: 'IFRS' }

export function GraphStatsBar({ stats, filters, onFrameworkChange }: GraphStatsBarProps) {
  const byType = stats?.by_type || {}
  return (
    <div className={cn(
      'flex items-center justify-between px-4 py-2',
      'bg-[var(--bg-surface,var(--bg-surface))] border-b border-white/[0.06]',
      'text-[11px] text-[var(--text-muted,#64748B)]',
    )}>
      <div className="flex items-center gap-3">
        <span className="font-semibold text-[var(--text-secondary,#94A3B8)]">
          Knowledge Graph
        </span>
        <span>{stats?.total_nodes ?? 0} nodes</span>
        <span>&middot;</span>
        <span>{stats?.total_edges ?? 0} edges</span>
        <span>&middot;</span>
        <div className="flex items-center gap-2">
          {Object.entries(byType).map(([type, count]) => {
            const th = NODE_THEME[type as keyof typeof NODE_THEME]
            return (
              <span key={type} className="flex items-center gap-1">
                <span className="inline-block h-2 w-2 rounded-full" style={{ background: th?.color || '#475569' }} />
                {count}
              </span>
            )
          })}
        </div>
      </div>
      <div className="flex items-center gap-1">
        <span className="mr-1 text-[10px]">Framework:</span>
        {FW_OPTIONS.map(fw => (
          <button
            key={fw}
            onClick={() => onFrameworkChange(fw)}
            className={cn(
              'px-2 py-0.5 rounded text-[10px] transition-colors',
              filters.framework === fw
                ? 'bg-[var(--accent,var(--accent))]/20 text-[var(--accent,var(--accent))] font-semibold'
                : 'text-[var(--text-muted,#64748B)] hover:text-[var(--text-secondary,#94A3B8)]',
            )}
          >
            {FW_LABELS[fw]}
          </button>
        ))}
      </div>
    </div>
  )
}
